var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 26,
    viewBox: "0 0 18 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 25.0201C4.76 25.0201 3.2 24.3567 1.92 23.0299C0.64 21.7031 0 20.0861 0 18.1788V5.11809C0 3.74982 0.47 2.5785 1.41 1.60413C2.35 0.629763 3.48 0.142578 4.8 0.142578C6.12 0.142578 7.25 0.629763 8.19 1.60413C9.13 2.5785 9.6 3.74982 9.6 5.11809V15.0691H7.8V5.11809C7.8 4.24737 7.51 3.51141 6.93 2.9102C6.35 2.309 5.64 2.00839 4.8 2.00839C3.96 2.00839 3.25 2.309 2.67 2.9102C2.09 3.51141 1.8 4.24737 1.8 5.11809V18.1788C1.8 19.5471 2.27 20.7184 3.21 21.6928C4.15 22.6671 5.28 23.1543 6.6 23.1543C7.18 23.1543 7.7252 23.0556 8.2356 22.8583C8.746 22.6609 9.2008 22.3864 9.6 22.0348V24.2738C9.14 24.5018 8.66 24.6834 8.16 24.8186C7.66 24.9538 7.14 25.021 6.6 25.0201ZM12 23.7762V20.0446H8.4V17.5569H12V13.8252H14.4V17.5569H18V20.0446H14.4V23.7762H12ZM6.6 18.1788V20.0446C5.76 20.0446 5.05 19.744 4.47 19.1428C3.89 18.5416 3.6 17.8056 3.6 16.9349V5.11809H5.4V16.9349C5.4 17.2874 5.5152 17.583 5.7456 17.8218C5.976 18.0606 6.2608 18.1796 6.6 18.1788ZM11.4 11.3375V5.11809H13.2V11.3375H11.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachWhite);
export default __webpack_public_path__ + "static/media/AttachWhite.3a2a9cf3a3a2faee9be99c0e260e37fe.svg";
export { ForwardRef as ReactComponent };